'use client'

import { cn } from '@/utilities/ui'

export function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window === 'undefined') return
        const cc = (window as Window & { CookieConsent?: { showPreferences: () => void } })
          .CookieConsent
        cc?.showPreferences()
      }}
      className={cn(
        'font-metropolis font-medium text-text-brand leading-[1.4] transition-opacity hover:opacity-80 cursor-pointer text-[14px] bg-transparent border-0 p-0',
        className,
      )}
    >
      Cookie-Einstellungen
    </button>
  )
}
